import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useBreakpoints from '#client/hooks/useBreakpoints';

const OPTIONS = [
  {
    icon: '/s2/material-icons/creditscorerounded.svg',
    title: 'Business cards',
    description:
      'Compare available card options, eligibility requirements, repayment terms, and rewards.'
  },
  {
    icon: '/s2/material-icons/accountbalancerounded.svg',
    title: 'Opening deposit',
    description: "Review each account's opening deposit and ongoing balance requirements."
  },
  {
    icon: '/s2/material-icons/checkboxrounded.svg',
    title: 'Additional perks',
    description:
      'Consider introductory bonuses, fees, financial tools, integrations, and customer support.'
  }
];

export const Benefits = () => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  return (
    <Stack spacing={4}>
      <Text
        color="primary"
        size={isMobile ? 'md' : 'xl'}
        weight="medium"
      >
        Need help choosing the right option for you?
      </Text>
      <Stack
        backgroundColor="common.white"
        borderRadius={2}
        direction={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        padding={3}
        spacing={4}
      >
        {OPTIONS.map((option) => (
          <Stack
            key={option.title}
            sx={{
              flex: 1,
              textWrapStyle: 'pretty'
            }}
          >
            <Box
              backgroundColor="background.green.light"
              borderRadius={1}
              padding={1.5}
              width="fit-content"
            >
              <SharedAsset
                alt=""
                color="success.dark"
                src={option.icon}
                width={22}
              />
            </Box>
            <Text
              color="primary"
              paddingBottom={1}
              paddingTop={2}
              size={isMobile ? 'sm' : 'md'}
              weight="medium"
            >
              {option.title}
            </Text>
            <Text size={isMobile ? 'sm' : 'md'}>{option.description}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
